import React from "react";
import "./Processing.css";
import { useStateValue } from "./StateProvider";
import { actionTypes } from "./reducer";
import { CircularProgress } from "@mui/material";


function Processing() {
  const [{ showProcessing }, dispatch] = useStateValue();

  return (
    <React.Fragment>
      {showProcessing?.show === true && (
        <div id="processing-wrap">
          <div
            className={`processing-backdrop ${
              showProcessing?.show === true && `show`
            }`}
          ></div>
          <div
            className={`d-flex justify-content-center align-items-center position-fixed h-100 w-100 processing-now-wrap`}
          >
            <div className="processing-now text-center">
              <CircularProgress size={150} style={{color: "#fff",margin: "0 auto"}} />
              <div className="processing-text mt-1">{showProcessing?.title}</div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Processing;
